import { render, staticRenderFns } from "./ItemForm.vue?vue&type=template&id=288a4c0e&scoped=true&lang=pug&"
import script from "./ItemForm.vue?vue&type=script&lang=ts&"
export * from "./ItemForm.vue?vue&type=script&lang=ts&"
import style0 from "./ItemForm.vue?vue&type=style&index=0&id=288a4c0e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288a4c0e",
  null
  
)

export default component.exports